module.exports = __webpack_public_path__ + "static/media/logo.793f3792.png";